import { render, staticRenderFns } from "./Index copy.vue?vue&type=template&id=773f2509&scoped=true&"
import script from "./Index copy.vue?vue&type=script&lang=js&"
export * from "./Index copy.vue?vue&type=script&lang=js&"
import style0 from "./Index copy.vue?vue&type=style&index=0&id=773f2509&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "773f2509",
  null
  
)

component.options.__file = "Index copy.vue"
export default component.exports